import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { STOGarantBanner } from '../components/STOGarantBanner';
import { MapPinIcon, PhoneIcon, MailIcon, SendIcon } from 'lucide-react';
import { CustomerReviews } from '../components/CustomerReviews';
export default function ContactPage() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-319">
      <Header data-id="element-320" />
      <main className="flex-grow" data-id="element-321">
        {/* Hero Section */}
        <section className="relative w-full h-[40vh] bg-cover bg-center" data-id="element-322">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1527824404775-dce343118ebc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80')"
        }} data-id="element-323">
            <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-324"></div>
          </div>
          <div className="container mx-auto px-4 h-full flex items-center justify-center relative z-10" data-id="element-325">
            <div className="text-center text-white max-w-4xl" data-id="element-326">
              <h1 className="text-5xl md:text-6xl font-bold mb-4" data-id="element-327">
                Contact Us
              </h1>
              <p className="text-xl" data-id="element-328">
                Have questions or ready to plan your next hiking adventure?
                We're here to help!
              </p>
            </div>
          </div>
        </section>
        {/* Contact Section */}
        <section className="py-16 bg-white w-full" data-id="element-329">
          <div className="container mx-auto px-4" data-id="element-330">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto" data-id="element-331">
              {/* Contact Info */}
              <div data-id="element-332">
                <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-333">
                  Get In Touch
                </h2>
                <p className="text-lg text-gray-700 mb-8" data-id="element-334">
                  We'd love to hear from you! Whether you have questions about
                  our trips, need help planning your adventure, or want to
                  provide feedback, please don't hesitate to reach out.
                </p>
                <div className="space-y-6" data-id="element-335">
                  <div className="flex items-start" data-id="element-336">
                    <MapPinIcon size={24} className="text-teal-600 mr-4 mt-1 flex-shrink-0" data-id="element-337" />
                    <div data-id="element-338">
                      <h3 className="text-lg font-semibold text-gray-800" data-id="element-339">
                        Our Location
                      </h3>
                      <p className="text-gray-700" data-id="element-340">
                        Office: The Hague, the Netherlands
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-341">
                    <PhoneIcon size={24} className="text-teal-600 mr-4 mt-1 flex-shrink-0" data-id="element-342" />
                    <div data-id="element-343">
                      <h3 className="text-lg font-semibold text-gray-800" data-id="element-344">
                        Phone
                      </h3>
                      <p className="text-gray-700" data-id="element-345">
                        Tel. +31 681180400 (Netherlands)
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-346">
                    <MailIcon size={24} className="text-teal-600 mr-4 mt-1 flex-shrink-0" data-id="element-347" />
                    <div data-id="element-348">
                      <h3 className="text-lg font-semibold text-gray-800" data-id="element-349">
                        Email
                      </h3>
                      <p className="text-gray-700" data-id="element-350">Experiencehikes@gmail.com</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-351">
                    <div className="text-teal-600 mr-4 mt-1 flex-shrink-0" data-id="element-352">
                      <span className="font-bold" data-id="element-353">KVK</span>
                    </div>
                    <div data-id="element-354">
                      <h3 className="text-lg font-semibold text-gray-800" data-id="element-355">
                        Chamber of Commerce
                      </h3>
                      <p className="text-gray-700" data-id="element-356">nr. 77858786</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Contact Form */}
              <div className="bg-gray-50 p-8 rounded-lg shadow-md" data-id="element-357">
                <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-358">
                  Send Us a Message
                </h2>
                <form className="space-y-6" data-id="element-359">
                  <div data-id="element-360">
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-361">
                      Your Name
                    </label>
                    <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="Enter your name" required data-id="element-362" />
                  </div>
                  <div data-id="element-363">
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-364">
                      Your Email
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="Enter your email" required data-id="element-365" />
                  </div>
                  <div data-id="element-366">
                    <label htmlFor="subject" className="block text-gray-700 font-medium mb-2" data-id="element-367">
                      Subject
                    </label>
                    <input type="text" id="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="What is this regarding?" required data-id="element-368" />
                  </div>
                  <div data-id="element-369">
                    <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-370">
                      Message
                    </label>
                    <textarea id="message" rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="Your message here..." required data-id="element-371"></textarea>
                  </div>
                  <button type="submit" className="bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-6 rounded-md transition duration-300 flex items-center" data-id="element-372">
                    Send Message
                    <SendIcon size={18} className="ml-2" data-id="element-373" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
        {/* Customer Reviews Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-374">
          <div className="container mx-auto px-4" data-id="element-375">
            <div className="text-center mb-12" data-id="element-376">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-377">
                What Our Hikers Say
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-378">
                Read what previous travelers have experienced on our hiking
                adventures
              </p>
            </div>
            <CustomerReviews data-id="element-379" />
          </div>
        </section>
        <STOGarantBanner data-id="element-380" />
      </main>
      <Footer data-id="element-381" />
    </div>;
}